import React, { useState } from 'react';

const ManageAdmins = () => {
    const [admins, setAdmins] = useState([{ id: 1, name: 'Admin1' }]);

    const handleDelete = (id: number) => {
        setAdmins(admins.filter((admin) => admin.id !== id));
    };

    return (
        <div className="p-8 text-ez-text-primary dark:text-ez-text-primary">
            <h2 className="text-2xl font-bold mb-6">Manage Admins</h2>
            <ul className="space-y-3">
                {admins.map((admin) => (
                    <li key={admin.id} className="flex items-center justify-between rounded-xl border border-ez-border dark:border-ez-border bg-white dark:bg-ez-surface px-4 py-3">
                        <span>{admin.name}</span>
                        <button onClick={() => handleDelete(admin.id)} className="rounded-lg bg-red-500 px-3 py-2 text-white hover:bg-red-600 transition">Delete</button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ManageAdmins;

